export default "__VITE_ASSET__CLgUYAye__"